/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_InteractiveInputs */

const en_home_bench_interactive = /** @type {(inputs: Home_Bench_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactive example`)
};

const lv_home_bench_interactive = /** @type {(inputs: Home_Bench_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interaktīvs piemērs`)
};

/**
* | output |
* | --- |
* | "Interactive example" |
*
* @param {Home_Bench_InteractiveInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_interactive = /** @type {((inputs?: Home_Bench_InteractiveInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_InteractiveInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_interactive(inputs)
	return en_home_bench_interactive(inputs)
});